import { Injectable } from '@angular/core';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EmpresaDGIResponse, EmpresaDGI } from './empresas-dgi.model';

@Injectable({
  providedIn: 'root'
})
export class EmpresaDGIService {
  url: string;
  endpoint = 'empresaDGI';

  constructor(private http: HttpClient) {}

  getEmpresaDGI(rut: string): Observable<EmpresaDGI> {
    const params = new HttpParams().set('rut', rut);
    return this.http.get<EmpresaDGIResponse>(`${this.url}/${this.endpoint}/`, { params }).pipe(
      map((response) => response.empresa)
    );
  }
}

